/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_ManufacturersInputs */

const en_nav_manufacturers = /** @type {(inputs: Nav_ManufacturersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manufacturers`)
};

/**
* | output |
* | --- |
* | "Manufacturers" |
*
* @param {Nav_ManufacturersInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const nav_manufacturers = /** @type {((inputs?: Nav_ManufacturersInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_ManufacturersInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_nav_manufacturers(inputs)
});